import React from 'react';
import PropTypes from 'prop-types';

import Buttonlet from 'components/Buttonlet';
import Image from 'components/Image';

export default function MessageComponent({
  children,
  data,
  deletable,
  onDelete,
}) {
  const {
    ago,
    description,
    image,
    title,
  } = data;
  return (
    <div className="media--message">
      <div className="media__left message__left">
        <span className="message__image">
          <Image
            className="media__object"
            icon={image}
            alt="A Message"
            width={40}
            height={52}
            defaultCursor
          />
        </span>
      </div>
      <div className="media__body message__body">
        {deletable && (
          <div className="message__delete-button-container">
            {deletable && <Buttonlet onClick={onDelete} type="close" />}
          </div>
        )}
        <div>
          {ago && (
            <b>
              (
              {ago}
              )
            </b>
          )}
          {' '}
          <span>{title}</span>
        </div>
        <div className="message__description" dangerouslySetInnerHTML={{ __html: description }} />
        <div className="buttons">
          {children}
        </div>
      </div>
    </div>
  );
}

MessageComponent.propTypes = {
  children: PropTypes.node,
  data: PropTypes.shape({
    ago: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
  deletable: PropTypes.bool,
  onDelete: PropTypes.func,
};

MessageComponent.defaultProps = {
  children: null,
  deletable: false,
  onDelete: () => {
  },
};